import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { Loading } from '@ebsco-ui/ebsco-ui';

import { Image } from '@app/components';
import { sharedMessages } from '@app/translations';
import { ShapeWithClassName } from '@app/constants';

import { getInstanceDefaultCover } from './getInstanceDefaultCover';

import css from './CoverImageContainer.module.scss';

interface CoverImageContainerProps {
  src?: string;
  altText?: string;
  sourceTypes?: string;
  isLoading?: boolean;
  imageClassName?: string;
}

export const CoverImageContainer: FC<
  ShapeWithClassName<CoverImageContainerProps>
> = ({
  sourceTypes,
  altText = '',
  src,
  isLoading,
  imageClassName,
  className,
}) => {
  const { $t } = useIntl();

  const defaultInstanceCover = getInstanceDefaultCover(sourceTypes);

  if (isLoading) {
    return (
      <div className={imageClassName} data-auto="loader-wrapper">
        <Loading
          loadingMessage={$t(sharedMessages.loadingMessage)}
          showMessage={false}
          size="small"
        />
      </div>
    );
  }

  return src ? (
    <Image src={src} className={imageClassName} alt={altText} />
  ) : (
    <div className={cn(css.imageWrapper, className)}>
      <img
        data-auto="default-instance-image"
        src={defaultInstanceCover}
        alt={altText}
      />
    </div>
  );
};
